const OPERADORES = [
  { 
    value: 1,
    name: 'Igual',
    nombreTag: ' es igual a ',
  },
  { 
    value: 2,
    name: 'Contiene',
    nombreTag: ' contiene ',
  },
  { 
    value: 3,
    name: 'Empieza por',
    nombreTag: ' empieza por ',
  },
  { 
    value: 4,
    name: 'Existe',
    nombreTag: ' existe ',
  },
  { 
    value: 5,
    name: 'No existe',
    nombreTag: ' existe ',
  },
]

export {
  OPERADORES
}
